// extracted by mini-css-extract-plugin
export default {"container":"RichText_container__9sGTI"};